import type { ReactNode } from 'react';

import css from './styles.module.css';

interface StepNumberProps {
	value: number;
}

export function StepNumber({ value }: StepNumberProps): ReactNode {
	return <span className={css.step}>{value}</span>;
}
